(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  // [LG] Barra de ventajas: en móvil/tablet muestra una ventaja cada vez
  (function () {
    var INTERVAL = 4500;
    var mq = window.matchMedia('(max-width: 989px)');

    function initAnn(root) {
      if (root.dataset.lgAnnReady) return;
      root.dataset.lgAnnReady = 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('.lg-ann__item'));
      if (items.length < 2) return;
      var index = 0;
      var paused = false;

      function show(i) {
        items[index].classList.remove('is-active');
        index = (i + items.length) % items.length;
        items[index].classList.add('is-active');
      }

      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) {
        root.addEventListener(ev, function () { paused = false; }, { passive: true });
      });

      setInterval(function () {
        if (!mq.matches || paused || document.hidden) return;
        show(index + 1);
      }, INTERVAL);
    }

    function initAll() {
      document.querySelectorAll('[data-lg-ann]').forEach(initAnn);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  // Velocidad constante del marquee en px/s (10 es ultra pausado y premium)
  var LG_MARQUEE_SPEED = 10;

  function lgResetAnnouncementMessage(message) {
    var track = message.querySelector(':scope > .lg-marquee-track');
    message.classList.remove('lg-marquee');
    message.style.removeProperty('white-space');
    if (!track) return message.querySelector(':scope > span');

    var text = track.querySelector('span') ? track.querySelector('span').textContent : '';
    var span = document.createElement('span');
    span.textContent = text;
    message.replaceChild(span, track);
    return span;
  }

  function lgMeasureAnnouncementOverflow() {
    document.querySelectorAll('.announcement-bar__message').forEach(function (message) {
      var span = lgResetAnnouncementMessage(message);
      if (!span) return;

      var prevWS = span.style.whiteSpace;
      span.style.whiteSpace = 'nowrap';
      var naturalWidth = span.scrollWidth;
      span.style.whiteSpace = prevWS || '';

      var containerWidth = message.clientWidth;
      
      // Si el texto cabe entero en el ancho disponible, se mantiene estático y visible completo
      if (naturalWidth <= containerWidth) return;

      var text = span.textContent;
      var track = document.createElement('span');
      track.className = 'lg-marquee-track';

      var copyA = document.createElement('span');
      copyA.textContent = text;
      var copyB = document.createElement('span');
      copyB.textContent = text;
      copyB.setAttribute('aria-hidden', 'true');

      track.appendChild(copyA);
      track.appendChild(copyB);
      message.replaceChild(track, span);

      var travel = copyA.getBoundingClientRect().width;
      message.style.setProperty('--lg-marquee-duration', Math.max(6, travel / LG_MARQUEE_SPEED) + 's');
      message.classList.add('lg-marquee');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lgMeasureAnnouncementOverflow);
  } else {
    lgMeasureAnnouncementOverflow();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(lgMeasureAnnouncementOverflow);
  }

  var lgAnnouncementResizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(lgAnnouncementResizeTimer);
    lgAnnouncementResizeTimer = window.setTimeout(lgMeasureAnnouncementOverflow, 150);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
